module.exports = __webpack_public_path__ + "static/media/UG.e80e0413.svg";